<template>
    <mu-flat-button label="Flat 按钮"  style="transform:scale(1.2)"/>
</template>
<script>
export default {
    name: 'FlatButton'
}
</script>



// WEBPACK FOOTER //
// FlatButton.vue?1e0ac92f